<div class="overlay domain-selector ">

    <div class="overlay-header">
        <h2>Choose a Domain</h2>
    </div>
    <div class="section-divider"></div>
    <form #domainSelecterForm="ngForm" autocomplete="off">
        <div class="overlay-body">
            <div class="container">
              <mat-radio-group color="primary" class="domain-selection" disableRipple [(ngModel)]="selectedDomain" name="domain">
                <mat-radio-button *ngFor="let domain of domains" [value]="domain">
                  {{ getLabel(domain) }}
                </mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="domains.length === 0">
                <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
                No domains available
              </mat-error>
            </div>
        </div>
    </form>
    <div class="section-divider"></div>
<div class="button-controls">
  <f-button text="Close" title="Close" type="button" variant="action" (click)="closeDomainSelector()">
  </f-button>
  <f-button text="Submit" title="Submit" variant="progressive" [disabled]="!selectedDomain" (click)="onSubmit()">
  </f-button>
</div>
  </div>